export default "__VITE_ASSET__VR$npbAF__"